import { ThunkDispatch } from 'redux-thunk';
import { beginFetch, endFetch } from 'common/modules/app/fetch';
import { postAccessTokenRequest } from 'common/utils/request/sas-request';
import { PostAccessTokenResponse } from 'common/utils/request/sas-response';
import { request } from 'common/utils/request/http-request';
import { saveCookie, SasCookieKeys } from 'common/utils/cookie-utils';

const POST_ACCESS_TOKEN_ID = 'post_access_token';

/**
 * トークン更新
 */
export const postAccessToken = (accessToken: string, refreshToken: string) => {
  return async (
    dispatch: ThunkDispatch<Record<string, unknown>, void, any>
  ) => {
    dispatch(beginFetch(POST_ACCESS_TOKEN_ID));

    const requestData = postAccessTokenRequest(accessToken, refreshToken);
    const response = await request(
      requestData.url,
      requestData.config,
      false,
      false
    );
    if (!response.error) {
      // 成功の場合、新規トークン情報をCookieに保存
      const body: PostAccessTokenResponse = (response.body as unknown) as PostAccessTokenResponse;
      saveCookie(SasCookieKeys.KEY_TOKEN, body.accessToken, 0, 'Strict');
      saveCookie(
        SasCookieKeys.KEY_REFRESH_TOKEN,
        body.refreshToken,
        0,
        'Strict'
      );
    }

    dispatch(endFetch(POST_ACCESS_TOKEN_ID));
  };
};
